import { useEffect, useRef, useState } from "react"


export default ({ phrase, content })=>{
    const [current, setCurrent] = useState(0);
    let init = false;
    const twister = useRef(null);
    const max = content.length;
    let maxLen = 0;
    for(let str of content){
        if(maxLen < str.length) maxLen = str.length;
    }
    useEffect(()=>{
        if(twister == null) return;
        setTimeout(() => {
            twister.current.className = '';
            let next = current + 1;
            if(next >= max) next = 0;
            setCurrent(next);
            setTimeout(() => {
                twister.current.className = 'animate';
            }, 50);
        }, 1600);
    },[current])
    return(
        <section className="banner endark">
            <div className="background">
                <video loading="lazy" aria-label="Banner con un video sobre Realidad Aumentada" src="./assets/videos/banner-ai.mp4" autoPlay muted playsInline loop />
            </div>
            <h1 className="twister">
                Mejora tu <span className={content[current] != "" ? 'animate': ''} style={{width: `${maxLen}ch`}} ref={twister}>{content[current]}</span> con Inteligencia Artificial
            </h1>
        </section>
    )
}